module.exports = __webpack_public_path__ + "static/img/2.ea6b80c.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/legao/2.jpg
// module id = 9Aq6
// module chunks = 1